import { IPreloadedState } from 'shared/types/redux';

export const selectSearchMetaRefreshing = (state: IPreloadedState) => state.searchMeta.isLoading;
